module.exports = __webpack_public_path__ + "static/1-3ae6fd3db4afca82726cfd2434bb595f.png";